import Vue from 'vue';
import VueRouter from 'vue-router';
import Layout from '../views/Layout.vue';
import Home from '../views/Home.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    component: Layout,
    children: [
      {
        path: '/',
        name: 'Home',
        component: Home,
        meta: {
          requiredNavbar: true,
        },
      },
      // {
      //   path: '/about',
      //   name: 'About',
      //   // route level code-splitting
      //   // this generates a separate chunk (about.[hash].js) for this route
      //   // which is lazy-loaded when the route is visited.
      //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
      // },
      {
        path: '/cart',
        name: 'CartList',
        component: () => import(/* webpackChunkName: "group-cart" */ '../views/CartList.vue'),
        meta: {
          requiredNavbar: true,
        },
      },
      {
        path: '/search-image',
        name: 'SearchImgGoodsList',
        component: () => import(/* webpackChunkName: "group-goods" */ '../views/SearchImgGoodsList.vue'),
        meta: {
          requiredNavbar: true,
        },
      },
      {
        path: '/goods/',
        name: 'Goods',
        component: () => import(/* webpackChunkName: "group-goods" */ '../views/Goods.vue'),
        meta: {
          requiredNavbar: true,
          hideCatePopup: true,
        },
        children: [
          {
            path: 'list',
            name: 'GoodsList',
            component: () => import(/* webpackChunkName: "group-goods" */ '../views/GoodsList.vue'),
            meta: {
              requiredNavbar: true,
              hideCatePopup: true,
            },
          },
          {
            path: 'detail/:id',
            name: 'GoodsDetail',
            component: () => import(/* webpackChunkName: "group-goods" */ '../views/GoodsDetail.vue'),
            props: true,
            meta: {
              requiredNavbar: true,
              hideCatePopup: true,
            },
          },
        ],
      },
      {
        path: '/about-us',
        name: 'AboutUs',
        component: () => import(/* webpackChunkName: "group-info" */ '../views/AboutUs.vue'),
        meta: {
          requiredNavbar: true,
        },
      },
      {
        path: '/contact-us',
        name: 'ContactUs',
        component: () => import(/* webpackChunkName: "group-info" */ '../views/ContactUs.vue'),
        meta: {
          requiredNavbar: true,
        },
      },
      {
        path: '/news',
        name: 'NewsList',
        component: () => import(/* webpackChunkName: "group-news" */ '../views/NewsList.vue'),
        meta: {
          requiredNavbar: true,
        },
      },
      {
        path: '/news/:id',
        name: 'NewsDetail',
        component: () => import(/* webpackChunkName: "group-news" */ '../views/NewsDetail.vue'),
        meta: {
          requiredNavbar: true,
        },
        props: true,
      },
      {
        path: '/info/',
        name: 'Information',
        component: () => import(/* webpackChunkName: "group-info" */ '../views/Information.vue'),
        meta: {
          requiredNavbar: true,
        },
        children: [
          {
            path: '/:id&:title',
            name: 'InformationContent',
            component: () => import(/* webpackChunkName: "group-info" */ '../views/InformationContent.vue'),
            props: true,
            meta: {
              requiredNavbar: true,
            },
          },
        ],
      },
      {
        path: '/user/',
        name: 'User',
        component: () => import(/* webpackChunkName: "group-user" */ '../views/User.vue'),
        meta: {
          requiredNavbar: true,
          login: true,
          hideFooter: true,
        },
        children: [
          {
            path: 'dashboard',
            name: 'UserDashboard',
            component: () => import(/* webpackChunkName: "group-user" */ '../views/UserDashboard.vue'),
            props: true,
            meta: {
              requiredNavbar: true,
              login: true,
              hideFooter: true,
              greyBackground: true,
            },
          },
          {
            path: 'favorite',
            name: 'UserFavoriteList',
            component: () => import(/* webpackChunkName: "group-user" */ '../views/UserFavoriteList.vue'),
            meta: {
              requiredNavbar: true,
              login: true,
              hideFooter: true,
              greyBackground: true,
            },
          },
          {
            path: 'order/',
            name: 'UserOrder',
            component: () => import(/* webpackChunkName: "group-user" */ '../views/UserOrder.vue'),
            meta: {
              requiredNavbar: true,
              login: true,
              hideFooter: true,
            },
            children: [
              {
                path: '/',
                name: 'UserOrderList',
                component: () => import(/* webpackChunkName: "group-user" */ '../views/UserOrderList.vue'),
                props: true,
                meta: {
                  login: true,
                  hideFooter: true,
                },
              },
              {
                path: 'detail/:id',
                name: 'UserOrderDetail',
                component: () => import(/* webpackChunkName: "group-user" */ '../views/UserOrderDetail.vue'),
                props: true,
                meta: {
                  login: true,
                  hideFooter: true,
                },
              },
            ],
          },
          // {
          //   path: 'order',
          //   name: 'UserOrderList',
          //   component: () => import(/* webpackChunkName: "group-user" */ '../views/UserOrderList.vue'),
          //   props: true,
          //   meta: {
          //     requiredNavbar: true,
          //     login: true,
          //   },
          // },
          {
            path: 'address',
            name: 'UserAddressList',
            component: () => import(/* webpackChunkName: "group-user" */ '../views/UserAddressList.vue'),
            meta: {
              requiredNavbar: true,
              login: true,
            },
          },
          {
            path: 'account',
            name: 'UserAccountSettings',
            component: () => import(/* webpackChunkName: "group-user" */ '../views/UserAccountSettings.vue'),
            meta: {
              requiredNavbar: true,
              login: true,
            },
          },
        ],
      },
      {
        path: '/feedback/',
        name: 'Feedback',
        component: () => import(/* webpackChunkName: "group-other" */ '../views/Feedback.vue'),
        meta: {
          requiredNavbar: true,
        },
      },
    ],
  },
  {
    path: '/place-order/:goods',
    name: 'PlaceOrder',
    component: () => import(/* webpackChunkName: "group-cart" */ '../views/PlaceOrder.vue'),
    props: true,
    meta: {},
  },
  {
    path: '/pay/:id',
    name: 'PayNow',
    component: () => import(/* webpackChunkName: "group-cart" */ '../views/PayNow.vue'),
    props: true,
    meta: {},
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import(/* webpackChunkName: "group-login" */ '../views/Register.vue'),
  },
  {
    path: '/login',
    name: 'LogIn',
    component: () => import(/* webpackChunkName: "group-login" */ '../views/LogIn.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { x: 0, y: 0 };
  },
});

export default router;
